module.exports = __webpack_public_path__ + "img/log_out.c6a8b074.svg";